import React, { useState } from "react";
import Icon from "../Icon";
import { useNavigate } from "react-router-dom";
import Modal from "../Modal";
import Button from "../Button";
import { hasPermission } from "../../services/auth";

export const ProductPriceAlert = ({ product }) => {
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();

    if (product?.has_api_keys || product?.origin === 'site' || product?.has_integration === false) return null;

    const goToIntegrations = () => {
        setShowModal(false);
        navigate("/integration/list");
    };

    return (
        <>
            <button
                type="button"
                className="btn-product-price-alert"
                onClick={(e) => {
                    e.stopPropagation();
                    setShowModal(true);
                }}
                title="O preço não está sendo atualizado"
            >
                <Icon name="alert" />
            </button>
            <div onClick={(e) => e.stopPropagation()}>
                <Modal
                    className="modal-product-price-alert"
                    show={showModal}
                    title="Preço desatualizado"
                    close={() => setShowModal(false)}
                    footer={
                        <>
                            <Button
                                type="secondary"
                                size="small"
                                text="Fechar"
                                action={() => setShowModal(false)}
                            />
                            {hasPermission('view_integration') &&
                                <Button
                                    type="primary"
                                    size="small"
                                    text="Ir para integrações"
                                    action={goToIntegrations}
                                />
                            }
                        </>
                    }
                >
                <div className="product-price-alert-content">
                    <div className="product-price-alert-content__icon">
                        <Icon name="alert" />
                    </div>
                    <p className="product-price-alert-content__message">
                        Você ainda não informou a API desse fornecedor e por isso o preço não está sendo atualizado.
                    </p>
                    <p className="product-price-alert-content__hint">
                        Acesse a tela de integrações para configurar e habilitar a atualização automática de preços.
                    </p>
                </div>
            </Modal>
            </div>
        </>
    );
};

export default ProductPriceAlert;
